import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class ConeEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITCONE;
}